var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    className: "default"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 19.33L15.34 12 23 4.67v14.66zM1.75 20l7.63-7.31 2.27 2.17c.1.09.23.14.35.14.12 0 .25-.05.35-.14l2.27-2.17L22.25 20H1.75zM1 4.67L8.66 12 1 19.33V4.67zM22.25 4l-7.63 7.31-.729.69L12 13.81 10.109 12l-.729-.69L1.75 4h20.5zm1.7-.29a.957.957 0 00-.66-.66A.93.93 0 0023 3H1c-.1 0-.2.02-.29.05a.957.957 0 00-.66.66A.93.93 0 000 4v16c0 .1.02.2.05.29A1.002 1.002 0 001 21h22a1.002 1.002 0 00.95-.71A.93.93 0 0024 20V4c0-.1-.02-.2-.05-.29z",
    id: "Fill-1",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "email-selected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    className: "alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(0 3)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3L8.66 9 0 .72M24 1c0-.1-.02-.19-.05-.28L15.34 9 24 17.3m-.78.7l-8.6-8.31-2.27 2.17c-.1.09-.23.14-.35.14-.12 0-.25-.05-.35-.14L9.38 9.69.7 18",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 0c.08 0 .15.01.22.03L22.21 1l-7.59 7.31-.729.69L12 10.81 10.109 9l-.729-.69L1.79 1 .8 0",
    id: "Fill-4"
  })))));
}
SvgEmail.displayName = 'Email';
export default SvgEmail;